import { FEATURES } from '@/constants/features';
import { canAccessFeature } from '@/utils/access';

export function canUseAgentPopup(user) {
  return !!user && !!user.is_superuser && canAccessFeature(FEATURES.MODULE_AGENT) && canAccessFeature(FEATURES.ACTION_AGENT_READ_LIBRARY);
}
